const getOptions = state => state.options.options;

const optionsSelectors = {
  getOptions,
};

export default optionsSelectors;
